import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'select-editor',
  template: `
    <select
      [ngClass]="inputClass"
      class="form-control"
      [formControl]="formControl"
      [name]="cell.getId()"
      (click)="onClick.emit($event)"
      (keydown.enter)="onEdited.emit($event)"
      (keydown.esc)="onStopEditing.emit()"
    >
      <option value="">Select...</option>
      <option
        *ngFor="let option of cell.getColumn().getConfig()?.list"
        [value]="option.value"
        [selected]="option.value === cell.getValue()"
      >
        {{ option.title }}
      </option>
    </select>
  `,
  standalone: false
})
export class SelectEditorComponent extends DefaultEditor {
  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }
  constructor() {
    super();
  }
}
